import styled from "styled-components";
import InputWithLabel from "shared/components/InputWithLabel";
import InputWithDuplicateCheck from "shared/components/InputWithDuplicateCheck";
import { TeacherInputs } from "shared/types/teacher";
import { hw } from "features/homework/homeworkUi";

interface Props {
    teacherInputs: TeacherInputs;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    setIsDuplicated: React.Dispatch<React.SetStateAction<any>>;
}

const RequiredInputs = ({ teacherInputs, onChange, setIsDuplicated }: Props) => {
    return (
        <Container>
            <Title>필수 입력</Title>
            <Inputs>
                <InputWithDuplicateCheck
                    setIsDuplicated={setIsDuplicated}
                    required={true}
                    label="아이디"
                    name="id"
                    value={teacherInputs.id}
                    onChange={onChange}
                    table="User/Auth/Log"
                    field="id"
                />
                <InputWithLabel 
                    label="이름" 
                    value={teacherInputs.name} 
                    onChange={onChange} 
                    name="name"
                    required
                    placeholder="이름을 입력해주세요"
                />
                <InputWithLabel 
                    label="비밀번호" 
                    value={teacherInputs.password} 
                    onChange={onChange} 
                    name="password"
                    type="password"
                    required
                    placeholder="비밀번호를 입력해주세요"
                />
                <InputWithLabel 
                    label="비밀번호 확인" 
                    value={teacherInputs.password_check} 
                    onChange={onChange} 
                    name="password_check"
                    type="password"
                    required
                    placeholder="비밀번호를 다시 입력해주세요"
                />
            </Inputs>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: ${hw.bg};
    padding: 20px 22px;
    border-radius: 14px;
    border: 1px solid ${hw.border};
`

const Title = styled.h2`
    margin: 0;
    color: ${hw.text};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.02em;
`

const Inputs = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px 20px;

    @media (max-width: 800px) {
        grid-template-columns: 1fr;
    }
`

export default RequiredInputs;
